<template>
    <div id="overlay">
        <div id="text" class="border">
            <div>
                <div id="overlayHeader">
                    <h2>{{title}}</h2>
                </div>
                <form v-on:keyup.enter="enterTrigger">
                    <div class="form-group row ">
                        <label class="col-sm-1" for="timeInp"></label>
                        <label class="col-form-label" for="timeInp"> Nombre d'heures : </label>
                        <input v-on:focus="selectAll" class="form-control" type="text" id="timeInp" name="custom" min="00:00" max="24:00" v-model="time" placeholder="(H:M, X.X)">
                    </div>
                    <div class="form-group row d-flex justify-content-center">
                        <input v-on:keyup.down="filterDown" class="col-sm-10 form-control" type="text" id="filter" name="filter" v-model="customFilter" placeholder="Filtre ..." autocomplete="off">
                    </div>
                    <div class="form-group row ">
                        <label class="col-sm-1" for="filter"> </label>
                        <select id="projectSelect" class="custom-select col-sm-10" data-live-search="true" size="12" v-model="indexProj">
                            <optgroup label='Mes Projets' />
                            <option v-for="(proj, index) in filterProjects" :key="'project '+proj.id" v-bind:value="'2.'+index"> {{proj.name}}</option>
                        </select>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" for="comment"></label>
                        <textarea class="form-control col-sm-10" id="comment" rows="4" placeholder="Commentaire ..." v-model="com"></textarea>
                    </div>
                    <div class="form-group error row" v-if="errors.length">
                        <ul>
                            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </div>
                    <span id="cancel">
                        <b-icon v-on:click="toggleOverlay" icon="x-circle-fill" />
                    </span>
                    <div class="form-group row">
                        <div v-if="isEdit" class="col-sm-6">
                            <div class="btn btn-danger" v-on:click="deleteEvent(event.id)">Supprimer</div>
                        </div>
                        <div class="col-sm-6" v-if="isEdit">
                            <div class="btn btn-success" v-on:click="validEdit">Modifier</div>
                        </div>
                        <div id="valid" v-if="!isEdit">
                            <div class="btn btn-success" v-on:click="validForm">Valider</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    const axios = require('axios');

    export default {
        name: "EventOverlay",
        props: ['events', 'day', 'event', 'isEdit', 'year', 'month', 'overlay','userId'],
        data() {
            return {
                com: '',
                indexProj: '1.0',
                time: "00:00",
                projects: [],
                filterProjects: [],
                customFilter: '',
                id: 0, // only for edit otherwise ignored by the API 
                title: 'Nouvelle saisie',
                errors: [],
            }
        },
        created: function() {
            this.getProjects();
        },
        methods: {
            resetData: function() {
                this.time = "00:00";
                this.com = '';
                this.customFilter = '';
                this.id = 0;
                this.title = 'Nouvelle saisie';
                this.indexProj = '1.0';
                this.errors = [];
            },
            getProjects: function(){
                if(this.userId == 0) return;
                axios.get(this.$store.state.apiUrl + "project/user/" + this.userId, {
                    params: {
                        login: localStorage.login,
                        password: localStorage.pass
                    }
                })
                .then(response => (this.projects = response.data, this.filterProjects = this.projects))
                .catch((e) => {
                    this.printError(e);
                });
            },
            toggleOverlay: function() {
                this.resetData();
                this.$emit('cancel');
            },
            formatData: function() {
                var dura = this.processHours();
                if (dura == false) {
                    return false;
                }

                var project = null;
                var tmpIndex = this.indexProj.split('.');
                project = this.filterProjects[Number(tmpIndex[1])].id;

                return {
                    id: this.id,
                    billable: 1,
                    userId: Number(this.userId),
                    duration: dura,
                    projectId: project,
                    comment: this.com,
                    date: this.year + "-" + this.month + "-" + this.day
                };

            },
            validForm: function() {
                if (this.checkData()) {
                    var data = this.formatData();
                    if (data != false) {
                        this.$emit('addLog', data);
                        this.resetData();
                    }
                }
            },
            validEdit: function() {
                if (this.checkData()) {
                    var data = this.formatData();
                    if (data != false) {
                        this.$emit('editLog', data);
                        this.resetData();
                    }
                }
            },
            processHours: function() {
                if (this.time) {
                    if (this.time.includes('.')) {
                        var splitTime = this.time.split('.');
                        return Number(splitTime[0]) + ":" + Number(splitTime[1]) * 6 + ":00";
                    } else if (this.time.includes(':')) {
                        return this.time + ":00";
                    }
                    return this.time + ":00:00";
                }
                this.errors.push("L'heure est non valide");
                return false;
            },
            deleteEvent: function(id) {
                this.$emit('deleteLog', id);
                this.resetData();
            },
            checkData: function() {
                this.errors = [];
                const regex = new RegExp('^[0-9]{0,2}[:|.]?[0-9]{0,2}$');
                if (!this.time || !regex.test(this.time)) {
                    this.errors.push("Le format d'heure renseigné n'est pas valide");
                }
                if (this.errors.length > 0) {
                    return false;
                }
                return true;
            },
            enterTrigger: function(e) {
                if(e.shiftKey) return;
                if (this.isEdit) {
                    this.validEdit();
                } else {
                    this.validForm();
                }
            },
            filterDown: function() {
                document.getElementById('projectSelect').focus();
            },
            selectAll: function(event) {
                setTimeout(function() {
                    event.target.select();
                }, 0);
            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            }
        },
        watch: {
            userId: function(){
                this.getProjects();
            },
            customFilter: function() {
                this.indexProj = '2.0';
                this.filterProjects = this.projects.filter(p => p.name.toLowerCase().includes(this.customFilter.toLowerCase()));
            },
            overlay: function() {
                if (!this.overlay) {
                    this.resetData();
                } else {
                    
                    if (this.isEdit) {
                        this.title = 'Modification';
                        this.time = this.event.duration;
                        this.com = this.event.comment;
                        this.id = this.event.id;
                        this.projects.forEach((value, index) => {
                            if (value.id == this.event.project_id) {
                                this.indexProj = '2.' + index;
                            }
                        });
                    }else {
                        var minutes = 0;
                        var hours = 0;
                        if (this.events[this.day]) {
                            this.events[this.day].forEach((value) => {
                                var splitTime = value.duration.split(":");
                                minutes += Number(splitTime[1]);
                                if (minutes >= 60) {
                                    hours++;
                                    minutes -= 60;
                                }
                                hours += Number(splitTime[0]);
                            });
                        }
                        if (hours < 7) {
                            var lastMinutes = 0;
                            var lastHours = 7 - hours;

                            if (minutes > 0) {
                                lastMinutes = 60 - minutes;
                                lastHours--;
                            }

                            if (lastMinutes < 10) {
                                lastMinutes = "0" + lastMinutes;
                            }

                            if (lastHours < 10) {
                                lastHours = "0" + lastHours;
                            }
                            this.time = lastHours + ":" + lastMinutes;
                        } else {
                            this.time = "00:00";
                        }
                    }
                    document.getElementById('timeInp').focus();
                }
            },
        }
    };
</script>

<style scoped>
    #overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2;
    }

    #text {
        width: 40%;
        position: absolute;
        top: 50%;
        left: 50%;
        color: white;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 25px;
    }

    #timeInp {
        width: 10em;
    }

    #delete {
        display: flex;
        position: absolute;
        top: 0px;
        right: -14px;
        font-size: 38px;
    }

    #delete:hover {
        cursor: pointer;
    }

    #hourExample {
        margin-left: 10px;
        font-size: 12px;
        line-height: 30px;
    }

    .custom-control {
        display: flex;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
    }

    .form-group {
        margin-bottom: 0.8em;
        margin-top: 0.2em;
    }

    ul {
        list-style: none;
        text-align: left;
    }

    .error {
        display: flex;
        color: red;
        margin-left: auto;
        margin-right: auto;
    }

    form {
        background-color: white;
        color: black;
        font-size: 16px;
        margin: 10px;
    }

    h2 {
        background-color: white;
        color: black;
        width: 80%;
        margin: auto;
    }

    optgroup {
        color: #ebebe4;
        background-color: #636363;
    }

    #valid {
        margin: auto;
    }

    #cancel {
        position: absolute;
        top: 0px;
        right: 5px;
        color: red;
        font-size: 30px;
    }

    #cancel:hover {
        cursor: pointer;
    }

    @media screen and (max-width: 800px){
        #text{
            width: 60%;
            padding: 5%;
            height: 90%;
        }
        #projectSelect{
            height: 200px;
        }
    }

    @media screen and (max-width: 479px){
        #text{
            width: 60%;
            padding: 5%;
            height: 90%;
        }
        #text h2{
            font-size: 1.3em;
        }
        #projectSelect{
            height: 170px;
        }
        .border {
          width: 73% !important;
        }
        #text {
          left: 39.5%;
        }
    }
    
</style>